import "pixi-assetslist-loader"
import * as WebFont from "webfontloader";

export default class UIApplicationLoader {

  startLoad = async (parameters) =>{
      await this.loadMainAssets(parameters.assetsPath)
      await this.loadTexture()
      await this.loadFonts(parameters.fonts, parameters.fontsPath)
    // setTimeout(() => {
    //Signals.loadingAssetsComplete.dispatch()
    // }, 1500);

  }

  getLoaderResources(name){
    return this.loader.resources[name].data
  }

  loadMainAssets = async ( assetsPath) => {
    return new Promise(resolve => {
      this.loader = new PIXI.Loader()
      this.loader.add(assetsPath);
      this.loader.onComplete.once(() => {
        resolve()
      }, this)
      //this.loader.onProgress.add((e) => {})
      this.loader.load()
    })
  }

  loadTexture = () => {
    return new Promise(resolve => {
      const prepare = (textures, index) => {
        window.app.renderer.plugins.prepare.upload(textures[index], () => {
          if(index + 1 <= textures.length - 1) {
            prepare (textures, index + 1)
          } else {
            resolve()
          }
        })
      }

      const entries = Object.entries(this.loader.resources)
      const texturesList = []
      for (let i = 0; i < entries.length; i++) {
        let res = entries[i][1]
        if (res.texture) {
          texturesList.push(res.texture)
        }
      }
      if (window.app) {  /// ????
        prepare(texturesList, 0)
      }else{
        resolve()
      }
    })
  }

  loadFonts(fonts, fontsPath) {
    return new Promise(resolve => {
      WebFont.load({
        custom: {
          families: fonts,
          urls: [fontsPath]
        },
        active: (event) => {
          resolve()
        }
      });
    })
  }

}
